import { shallowEqual, useSelector } from 'react-redux';

import type { RootState } from '../../../../store';

export default function useIntakeTabStatuses() {
  return useSelector((state: RootState) => state.intakeQuestionnaire.tabStatuses, shallowEqual);
}
